import React from 'react';

const ClickToEditOverlay = () => {
  return (
    <div className="unlock-overlay" title="Click to Edit">
      <i className="zmdi zmdi-lock-open" />
    </div>
  );
};

export default ClickToEditOverlay;
